import { Cookies } from "react-cookie";
import { COOKIES } from "../../constants/misc";

export function saveAuthToken(token: string) {
    const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
    const cookies = new Cookies();
    cookies.set(COOKIES.token, token, {
        secure: ENV === "production",
        sameSite: "strict",
        path: "/",
        maxAge: 24 * 60 * 60 * 30
    });
    return;
}
